import { GeneralGetRequestOption } from "../../interfaces/request.interface";
import { Employee } from "../../interfaces/employee.interface";
import axios from "../../libs/axios";

export const getUsers = async (
  option?: GeneralGetRequestOption
): Promise<Employee[]> => {
  const response = await axios.get<Employee[]>("/users", {
    params: option,
  });
  return response.data;
};

export const getUserById = async (id: number | string): Promise<Employee> => {
  const response = await axios.get<Employee>(`/users/${id}`);
  return response.data;
};

export const countUser = async (
  option?: GeneralGetRequestOption
): Promise<number> => {
  const response = await axios.get<number>("/users/count", {
    params: option,
  });
  return response.data;
};

export const exportUserCSV = async (
  option?: GeneralGetRequestOption
): Promise<Blob> => {
  const response = await axios.get<Blob>("/users/exportEmployeeCSV/csv", {
    params: option,
    responseType: "blob",
  });

  return response.data;
};
